import { render, staticRenderFns } from "./quickorderCardProductMovil_child.vue?vue&type=template&id=71d812fc&scoped=true"
import script from "./quickorderCardProductMovil_child.vue?vue&type=script&lang=js"
export * from "./quickorderCardProductMovil_child.vue?vue&type=script&lang=js"
import style0 from "./quickorderCardProductMovil_child.vue?vue&type=style&index=0&id=71d812fc&prod&lang=scss&scoped=true"
import style1 from "./quickorderCardProductMovil_child.vue?vue&type=style&index=1&id=71d812fc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d812fc",
  null
  
)

export default component.exports